export const getMathRandom = (min: number, max: number) => {
    return Math.floor(Math.random() * (max - min)) + min;
};

export const getMathRandomPercent = (min: number, max: number): string => {
    return `${Math.floor(Math.random() * (max - min)) + min}%`;
};
